<div class="container py-4 product-detail-page" *ngIf="!loading; else loadingTpl">
  <!-- Botón volver (visible siempre) -->
  <div class="mb-3">
    <button class="btn btn-outline-secondary btn-sm" (click)="inicio()">
      <i class="fas fa-arrow-left me-2"></i> Volver al inicio
    </button>
  </div>

  <div class="card shadow border-0 overflow-hidden">
    <!-- Imagen principal -->
    <div class="position-relative">
      <img *ngIf="product?.photo; else noImage" [src]="product.photo" class="card-img-top img-fluid"
        [alt]="product?.nombre" style="max-height: 500px; object-fit: contain; background: #f8f9fa;" />
      <ng-template #noImage>
        <div class="no-image-placeholder d-flex align-items-center justify-content-center bg-light"
          style="height: 300px;">
          <i class="fas fa-box-open fa-4x text-muted"></i>
        </div>
      </ng-template>
    </div>

    <div class="card-body p-4 p-md-5">
      <div class="row">
        <!-- Columna principal (info + precios) -->
        <div class="col-lg-8">
          <h1 class="h3 fw-bold mb-2">{{ product.nombre }}</h1>

          <p class="text-muted small mb-3">
            <strong>SKU:</strong> {{ product.serie || '—' }}
          </p>

          <!-- Precios -->
          <div class="prices-section mb-4">
            <div class="d-flex flex-wrap align-items-baseline gap-3 mb-2">
              <div>
                <span class="badge bg-success fs-6 px-3 py-2">
                  Precio Contado
                </span>
                <div class="h2 text-success fw-bold mt-1 mb-0">
                  ${{ product.precioCon | number:'1.2-2' }}
                </div>
              </div>

              <div class="text-muted small">
                <del class="text-decoration-line-through">
                  ${{ product.precioLis | number:'1.2-2' }}
                </del>
                <br>
                <span class="text-success fw-bold">
                  Ahorrás ${{ (product.precioLis - product.precioCon) | number:'1.2-2' }}
                  ({{ ((product.precioLis - product.precioCon) / product.precioLis * 100) | number:'1.0-0' }}%)
                </span>
              </div>
            </div>

            <!-- Precio lista y débito -->
            <p class="mb-1 text-muted">
              Precio de lista: <strong>${{ product.precioLis | number:'1.2-2' }}</strong>
            </p>

          </div>

          <!-- Colores -->
          <div class="mb-4" *ngIf="product.colores?.length">
            <h6 class="fw-bold mb-2">Colores disponibles:</h6>
            <div class="d-flex flex-wrap gap-3">
              <div *ngFor="let color of product.colores" class="text-center">
                <div class="color-swatch rounded-circle shadow-sm mx-auto" [style.backgroundColor]="color.hex"
                  [title]="color.nombre" style="width: 40px; height: 40px; border: 2px solid #fff;"></div>
                <small class="d-block text-muted mt-1">{{ color.nombre }}</small>
              </div>
            </div>
          </div>

          <!-- Descripción -->
          <div class="product-description mt-4">
            <h6 class="fw-bold mb-2">Descripción:</h6>
            <div class="text-muted" [innerHTML]="descripcionConSaltos"></div>
          </div>
        </div>

        <!-- Columna lateral (acciones) - en mobile se mueve abajo -->
        <div class="col-lg-4 mt-4 mt-lg-0">
          <div class="card bg-light border-0 shadow-sm p-4 sticky-top" style="top: 20px;">
            <div class="d-grid gap-3">
              <button class="btn btn-primary btn-lg fw-bold" (click)="addToCart()" [disabled]="product?.stock==0">
                <i class="fas fa-cart-plus me-2"></i>
                Agregar al carrito
              </button>

              <button class="btn btn-success btn-lg fw-bold" (click)="comprarAhora()" [disabled]="product?.stock==0">
                <i class="fas fa-bolt me-2"></i>
                Comprar ahora
              </button>

              <small class="text-center text-muted mt-2" *ngIf="product?.stock==0">
                <i class="fas fa-exclamation-triangle text-warning me-1"></i>
                Sin stock disponible
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-footer [conf]="conf" class="mt-5"></app-footer>
</div>

<!-- Loading -->
<ng-template #loadingTpl>
  <div class="d-flex flex-column align-items-center justify-content-center min-vh-100">
    <div class="spinner-border text-primary" style="width: 4rem; height: 4rem;" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="mt-4 text-muted fs-5">Cargando producto...</p>
  </div>
</ng-template>